import React from 'react'

const Dashboard = () => {
  return (
    <div className="m-5">
<h1 className='heading'>Dashboard</h1></div>
  )
}

export default Dashboard